import { SWITCH_MODE } from "../actions/types";
import produce from "immer";

const modeInitState = {
  reviewer: false,
};
export const mode = (state = modeInitState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SWITCH_MODE:
        draft.reviewer = !draft.reviewer;
        break;
      default:
    }
  });
